export default __webpack_public_path__ + "static/media/photoshop.fc84a83f.jpg";